export default {"src":"/_next/static/media/in.1bba125b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};